import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorInterceptor } from '@infra/http-interceptors/reedge.error.interceptor';
import { LocationInterceptor } from '@infra/http-interceptors/reedge.location.interceptor';
import { TimeZoneInterceptor } from '@infra/http-interceptors/reedge.timezone.interceptor';
import { JwtInterceptor } from '@infra/http-interceptors/reedge.unauthorized.interceptor';
import { VersionInterceptor } from '@infra/http-interceptors/reedge.version.interceptor';

export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: VersionInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: LocationInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: TimeZoneInterceptor, multi: true },
];
